<!-- <div #dialog> -->
  <!-- Modal Header -->
  <ng-container>
    <div class="cx-modal-container">
      <div class="cx-modal-content">
        <header class="cx-dialog-header modal-header saved-cart-modal-header">
          <div class="cx-dialog-title modal-title">
            {{ 'savedCart.extendExpiry' | cxTranslate }}
          </div>
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="dismissModal('Cross click')"
          >
            <span aria-hidden="true">
              <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
            </span>
          </button>
        </header>
        <div>
          <!-- Modal Body -->
          <div class="vs-dialog-body modal-body saved-cart-modal-body">
            <p class="dialog-hint">
              {{ 'savedCart.extendExpiryHint' | cxTranslate }}
            </p>
            <table>
              <tr>
                <th>{{ 'savedCart.cartName' | cxTranslate }}</th>
                <th>{{ 'savedCart.id' | cxTranslate }}</th>
                <th>{{ 'savedCart.totalLine' | cxTranslate }}</th>
              </tr>
              <tr>
                <td>{{ currentCart.name }}</td>
                <td>{{ currentCart.code }}</td>
                <td>{{ currentCart.totalItems }}</td>
              </tr>
            </table>
          </div>
          <footer class="modal-footer saved-cart-modal-footer">
            <!-- Actions -->
            <div class="vs-modal-buttons">
              <button
                class="btn vs-text-btn btnClass cancleBtnClass"
                (click)="dismissModal('Cancel create delete cart clicked')"
              >
                {{ 'savedCart.cancel' | cxTranslate }}
              </button>
              <button
                class="btn vs-primary-btn btnClass"
                (click)="extendExpiry()"
              >
                {{ 'savedCart.extend' | cxTranslate }}
              </button>
            </div>
          </footer>
        </div>
      </div>
    </div>
  </ng-container>
<!-- </div> -->
